/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewDetail extends models.SavedViewBase {
    getFixupPrototypeFunction() { return SavedViewDetail.fixupPrototype; }

    static newInstance(model: Partial<SavedViewDetail>): SavedViewDetail {
        let obj = Object.assign(new SavedViewDetail(), model);
        SavedViewDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewDetail>): SavedViewDetail {
        if (!model) return null;
        return SavedViewDetail.newInstance(<SavedViewDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewDetail) {
        if (!obj) return;

        models.SavedViewDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewDetail): boolean {
        if (models.SavedViewBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SavedViewDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Unique identifier of the saved view
     */
    id: string;

}
